import {
  BookingItemResourceInterface,
  CodesAttachementInterface,
} from '@sport-activities/sdk';

import { toDecimalPrice, toIntegerPrice } from '~/core/helpers/numbers.helper';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { SubscriptionInterface } from '../interfaces/subscription.interface';

export class Subscription implements SubscriptionInterface {
  public activity: Activity;
  public item: BookingItemResourceInterface;
  public timeslot: Timeslot;
  public codesAttachement?: CodesAttachementInterface;

  constructor(init: SubscriptionInterface) {
    this.activity = new Activity(init.activity);
    this.timeslot = new Timeslot(init.timeslot);
    this.item = init.item;
    this.codesAttachement = init.codesAttachement;
  }

  public get totalPrice(): number {
    return toDecimalPrice(
      toIntegerPrice(this.item.price * this.item.attendees.length)
    );
  }
}
